import request from '@/utils/request'

export function updateActiveSkinCfg(data) {
  return request({
    url: 'api/v1/active-skin/update',
    method: 'post',
    data: data
  })
}

export function getActiveSkinList(data) {
  return request({
    url: 'api/v1/active-skin/getList',
    method: 'post',
    data: data
  })
}

export function delActiveSkin(data) {
  return request({
    url: 'api/v1/active-skin/delete',
    method: 'delete',
    data: data
  })
}

export function getActiveSkinTypeList(data) {
  return request({
    url: 'api/v1/active-skin/getSkinList',
    method: 'post',
    data: data
  })
}

export function updateActiveSkinDir(data) {
  return request({
    url: 'api/v1/shop/updateGiftSkin',
    method: 'post',
    data: data
  })
}

export function getGiftCond(data) {
  return request({
    url: 'api/v1/shop/getRoleGiftCond',
    method: 'get',
    data: data
  })
}

